// ============================================================
// AccessDenied.js
// Shown when MSAL authentication succeeds but the signed-in UPN
// is not on the admin allowlist. The user can sign out and try
// again with a different account.
// ============================================================

import React from 'react';
import { useMsal } from '@azure/msal-react';
import { ShieldOff } from 'lucide-react';
import './AccessDenied.css';

export default function AccessDenied({ upn }) {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  return (
    <div className="access-denied">
      <div className="access-denied__content">
        <div className="access-denied__icon">
          <ShieldOff size={36} strokeWidth={1.75} />
        </div>
        <h1>Access denied</h1>
        <p>
          Your account isn't authorised for the A2Z CareHub admin portal.
          If you believe this is wrong, contact Zuber.
        </p>
        {upn && <p className="access-denied__upn">{upn}</p>}
        <button
          type="button"
          className="access-denied__signout"
          onClick={handleLogout}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
